import { fileUrl } from "@/lib/api";

export default function PageHero({ eyebrow, title, cover, alt, tall = false }) {
  if (cover) {
    return (
      <div className={`relative ${tall ? "h-[45vh] min-h-[320px]" : "h-[38vh] min-h-[260px]"} flex items-end`}>
        <img src={fileUrl(cover)} alt={alt || title} className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10 w-full">
          {eyebrow && <p className="font-accent italic text-brass text-lg">{eyebrow}</p>}
          <h1 className="font-serif text-4xl sm:text-5xl text-cream">{title}</h1>
        </div>
      </div>
    );
  }
  return (
    <div className="bg-oak-dark text-cream py-14 text-center">
      {eyebrow && <p className="font-accent italic text-brass text-lg">{eyebrow}</p>}
      <h1 className="font-serif text-4xl sm:text-5xl">{title}</h1>
    </div>
  );
}
